export default {
  form: {
    first_name: {
      label: 'Nombre',
    },
    last_name: {
      label: 'Apellido',
    },
    email: {
      label: 'Correo electrónico',
    },
    phone_number: {
      label: 'Número de teléfono',
    },
    birthday: {
      label: 'Fecha de nacimiento',
    },
    city: {
      label: 'Ciudad',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    success: 'Perfil actualizado correctamente',
    error: 'Error al actualizar el perfil',
  },
};
